module.exports = __webpack_public_path__ + "img/b4.201e62a3.png";